// extracted by mini-css-extract-plugin
export default {"mainWrapper":"TotalSavings_mainWrapper__EsRPF","wrapper":"TotalSavings_wrapper__9P6cf","header":"TotalSavings_header__3ewHl","column":"TotalSavings_column__j5eH4"};